import dictionary from 'config/dictionary';
import { isValid } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { formatVoucherExpiry } from 'utilities/formatVoucherExpiry';
import { getProductName } from 'utilities/huggg';
import { interpolateMany } from 'utilities/interpolate';
import styles from './expiration-date.module.scss';

const ExpirationDate = (props) => {
  const { huggg, voucherExpiry, isVoucherV2, hasFulfilledVoucher } = props;
  const { isSuperhuggg } = huggg;

  if (isVoucherV2 && !hasFulfilledVoucher && voucherExpiry) {
    return null;
  }

  const expiryDate = isSuperhuggg
    ? huggg.expiry
    : (voucherExpiry ?? huggg.expiry_date);

  const template = dictionary.stash.expirationRedesign;

  return expiryDate
    ? isValid(new Date(expiryDate)) && (
        <div className={styles.container}>
          <span className={styles.text}>
            {interpolateMany(template, [
              [
                '[expiration_date]',
                <strong key={null} className={styles.date}>
                  {formatVoucherExpiry(expiryDate, 'do MMM yyyy', huggg)}
                </strong>,
              ],
              ['[product_name]', <>{getProductName(huggg)}</>],
            ])}
          </span>
        </div>
      )
    : null;
};

ExpirationDate.propTypes = {
  huggg: PropTypes.object.isRequired,
  voucherExpiry: PropTypes.string,
  isVoucherV2: PropTypes.bool,
  hasFulfilledVoucher: PropTypes.bool,
};

export default ExpirationDate;
